import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { DeleteButton, EditLink } from "../_components/AdminRowActions";

const AirportItem = ({ deleteAirport, airport, count }) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{airport.airportname}</td>
    <td className={cellClass}>{airport.airport?.label}</td>
    <td className={cellClass}>{airport.city}</td>
    <td className={cellClass}>
      <AdminBadge tone={airport.isactive ? "success" : "neutral"}>
        {airport.isactive ? "Active" : "Inactive"}
      </AdminBadge>
    </td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <EditLink to={`/admin/airportlist/edit/${airport._id}`} label="Edit airport" />
        <DeleteButton
          label="Delete airport"
          onClick={() => deleteAirport(airport._id)}
        />
      </AdminRowActions>
    </td>
  </tr>
);

export default AirportItem;
